export default {
  LIST: {
    TITLE: `Structure list`,
    SUMMARY: ``
  },
  QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`
}
